import { baseGlobals } from '@root/typescript/baseGlobals'

import { ENativeDebugPanelEvent } from '@bc/v2/DebugPanel/definitions'

import preventCallback from './utils/preventCallback'
import preventContextMenu from './utils/preventContextMenu'

let isAllowedContextMenu = baseGlobals.isDev

if (!isAllowedContextMenu) {
  preventContextMenu(preventCallback)
}

/**
 * DebugPanel láthatóságának változásakor megfutó callback.
 * @param e - Event.
 */
function onDebugPanelSwitched (e: Event): void {
  const { isVisible } = (e as CustomEvent).detail
  // Csak akkor engedjük a jobb klikket, ha van debugpanel
  isAllowedContextMenu = isVisible

  if (isAllowedContextMenu) {
    window.removeEventListener('contextmenu', preventCallback)
  }
  else {
    preventContextMenu(preventCallback)
  }
}

// Ezt az eventet ne importáljuk a DebugPanelből, mert jön vele mindenféle más import is
document.addEventListener(ENativeDebugPanelEvent.Switched, onDebugPanelSwitched)
